var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"tile":"","type":"image","width":"100%","height":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }